import { registerTacticalPlugin } from "./registry";

registerTacticalPlugin({
  id: "viewshed",
  label: "Зона видимости",
  description: "Клик наблюдателя → полигон viewshed по рельефу (или круг без DEM).",
  activate: () => () => undefined,
});

export {};
